// Minimal old-school HTML theme - Light

export const light = {
    'background1': '#ffffff',
    'background2': '#ffffff',
    'text1': '#000000',
    'text2': '#000000',

    "navLink": {
        color: '#0000EE',
    },

    "activeTab": {
        color: "#000000",
        background: "transparent",
        fontWeight: "bold",
        textDecoration: "none",
        padding: "5px 10px",
    },

    "notActiveTab": {
        color: "#0000EE",
        background: "transparent",
        textDecoration: "underline",
        padding: "5px 10px",
    },

    ".notActiveTab:hover": {
        color: "#FF0000",
    },

    "workCard": {
        border: "1px solid #000000",
        background: "#ffffff",
        padding: "15px",
        marginBottom: "20px",
    },

    "workCardDetails ": {
        background: "#ffffff",
        padding: "10px 0",
    },

    "contactMeForm": {
        border: "1px solid #000000",
        background: "#ffffff",
        padding: "20px",
    },

    "input": {
        color: "#000000",
        border: "1px solid #000000",
        background: "#ffffff",
        padding: "5px",
        fontFamily: '"Courier New", Courier, monospace',
    }
}
